var React = require('react');

function CartIcon (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M41,10.55a1,1,0,0,0-.77-.38h-8L24.05.36A1,1,0,0,0,22.64.23a1,1,0,0,0-.13,1.41l7.1,8.53H13l6-8.6A1,1,0,0,0,17.31.43h0l-6.77,9.74H1a1,1,0,0,0-1,1,1.09,1.09,0,0,0,0,.26l6.32,24.1a1,1,0,0,0,1,.74H35.06a1,1,0,0,0,1-.79l5.15-24.1A1,1,0,0,0,41,10.55ZM34.25,34.27H8.09L2.3,12.17H39Z"})));
}

CartIcon.defaultProps = {"viewBox":"0 0 41.2 36.27"};

module.exports = CartIcon;

CartIcon.default = CartIcon;
